export default "__VITE_ASSET__BYQMQYJu__"